<script setup lang="ts">
  import { FlowContactsWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'

  useApiRequestsAbort()
</script>

<template>
  <FlowContactsWidget />
</template>
